import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.merge';
import RaisedButton from 'material-ui/RaisedButton';
import * as styles from './Button.scss';
import { connect } from 'react-redux';
var WarningButton = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(WarningButton, _Component);

  var _super = _createSuper(WarningButton);

  function WarningButton() {
    _classCallCheck(this, WarningButton);

    return _super.apply(this, arguments);
  }

  _createClass(WarningButton, [{
    key: "render",
    value: function render() {
      var style = merge({}, {
        borderRadius: 4,
        border: "2px solid ".concat(this.props.theme.colors.warningColor),
        minWidth: 120
      }, this.props.style);
      return /*#__PURE__*/React.createElement(RaisedButton, {
        backgroundColor: 'transparent',
        className: styles.button,
        fullWidth: true,
        label: this.props.label,
        labelStyle: {
          color: this.props.theme.colors.warningColor
        },
        onSubmit: this.props.onSubmit,
        onClick: this.props.onClick,
        rippleStyle: {
          backgroundColor: 'pink'
        },
        style: style,
        type: this.props.type
      });
    }
  }]);

  return WarningButton;
}(Component), _defineProperty(_class2, "propTypes", {
  label: PropTypes.string,
  style: PropTypes.object,
  onSubmit: PropTypes.func,
  onClick: PropTypes.func
}), _defineProperty(_class2, "defaultProps", {
  label: 'Submit',
  style: {},
  type: 'button',
  onSubmit: null,
  onClick: undefined
}), _temp)) || _class);
export { WarningButton as default };